<div class="flex flex-col">
  <div class="flex flex-row" *ngIf="reportMode=='none'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">

      <div class="flex flex-row padding10">
        <h4>Demographics Reports</h4>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row" *ngIf="reportMode=='none'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
        'bg-gray-600': sharedService.userTheme === 'dark',
        'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <form [formGroup]="reportGroup" class="w-full">

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table class="mat-elevation-z8 w-full">
                <tr>
                  <td>
                    <div class="flex flex-row">
                      <mat-form-field>
                        <mat-label>State Number</mat-label>
                        <input matInput formControlName="StateNumber">
                        <mat-error *ngIf="reportGroup.get('StateNumber').invalid">
                          Required Field.
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </td>
                  <td>
                    <div>
                      <button type="button" mat-raised-button color="primary" (click)="runReport()">
                        Run Report
                      </button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="flex flex-row" style="padding-bottom: 10px;" *ngIf="reportMode == 'list'">
    <button mat-icon-button matTooltip="Print" (click)="printLabDemographics()" [matTooltipShowDelay]="750">
      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">printer</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Return" (click)="cancel()" [matTooltipShowDelay]="750">
      <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
    </button>
  </div>

  <!-- Demographics -->
  <kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" margin="1cm">
    <div class="flex flex-col" *ngIf="reportMode == 'list'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Laboratory Report</h5>
              <span>Report Date: {{dateNow}}</span>
              <span style="width: 100%;border-top: 1px solid grey"></span>

              <div style="overflow-x:auto">
                <div class="flex flex-col">

                  <table class="mat-elevation-z8 w-full">
                    <tr>
                      <td style="font-weight: bold;">Lab Name</td>
                      <td>{{demog.labName}}</td>
                      <td style="font-weight: bold;"></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">State Number</td>
                      <td>{{demog.stateNumber}}</td>
                      <td style="font-weight: bold;">CLIA Number</td>
                      <td>{{demog.cliaNumber}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">NPI</td>
                      <td>{{demog.upn}}</td>
                      <td style="font-weight: bold;">Last Survey Date</td>
                      <td>{{demog.lastSurveyDate}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Certificate Type</td>
                      <td>{{demog.certificateType}}</td>
                      <td style="font-weight: bold;">Certificate Exp. Date</td>
                      <td>{{demog.cliaCertificateExpiration}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Closed</td>
                      <td>{{demog.closed}}</td>
                      <td style="font-weight: bold;">Closed Date</td>
                      <td>{{demog.closeDate}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Tax ID</td>
                      <td>{{demog.taxId}}</td>
                      <td style="font-weight: bold;">Complexity</td>
                      <td>{{demog.complexity}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Accreditation Code </td>
                      <td>{{demog.acCredit}}</td>
                      <td style="font-weight: bold;">Accreditation Number</td>
                      <td>{{demog.npi}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Phone</td>
                      <td>{{demog.phoneNumber}}</td>
                      <td style="font-weight: bold;"></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Mailing Address</td>
                      <td>{{demog.mailAddress}}</td>
                      <td style="font-weight: bold;">Site Address</td>
                      <td>{{demog.siteAddress}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Mailing City</td>
                      <td>{{demog.mailCity}}</td>
                      <td style="font-weight: bold;">Site City</td>
                      <td>{{demog.siteCity}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Mailing State</td>
                      <td>{{demog.mailState}}</td>
                      <td style="font-weight: bold;">Site State</td>
                      <td>{{demog.siteState}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Mailing Zip</td>
                      <td>{{demog.mailZip}}</td>
                      <td style="font-weight: bold;">Site Zip</td>
                      <td>{{demog.siteZip}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Director</td>
                      <td>Name: {{demog.director}}<br />Phone: {{demog.directorPhone}}<br />Email:
                        {{demog.directorEmail}}
                      </td>
                      <td style="font-weight: bold;"></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Manager</td>
                      <td>Name: {{demog.manager}}<br />Phone: {{demog.managerPhone}}<br />Email: {{demog.managerEmail}}
                      </td>
                      <td style="font-weight: bold;"></td>
                      <td></td>
                    </tr>
                  </table>
                  <table class="mat-elevation-z8 w-full">
                    <tr>
                      <td style="font-weight: bold;">Associated Labs</td>
                      <td>
                        <mat-checkbox [checked]="demog.hst == 'Y'">HST</mat-checkbox>
                        <mat-checkbox [checked]="demog.soa == 'Y'">SOA</mat-checkbox>
                        <mat-checkbox [checked]="demog.shared == 'Y'">Shared</mat-checkbox>
                        <mat-checkbox [checked]="demog.multiple == 'Y'">Multiple</mat-checkbox>
                        <mat-checkbox [checked]="demog.lrn == 'Y'">Sentinel (LRN)</mat-checkbox>
                        <mat-checkbox [checked]="demog.outOfState == 'Y'">Out of State</mat-checkbox>
                        <mat-checkbox [checked]="demog.covidLab == 'Y'">Covid Lab</mat-checkbox>
                      </td>
                    </tr>
                  </table>
                  <table class="mat-elevation-z8 w-full">
                    <tr>
                      <td style="font-weight: bold;">Lab Type</td>
                      <td>{{demog.labType}}</td>
                      <td style="font-weight: bold;"></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Office Hours</td>
                      <td>{{demog.officeHours}}</td>
                      <td style="font-weight: bold;">Ownership Type</td>
                      <td>{{demog.ownerType}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">County Code</td>
                      <td>{{demog.cliaCertificateExpiration}}</td>
                      <td style="font-weight: bold;">Shared/Multiple Info</td>
                      <td>{{demog.sharedMulitText}}</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold;">Office HR</td>
                      <td>{{demog.certificateType}}</td>
                      <td style="font-weight: bold;">Office HR Comments</td>
                      <td>{{demog.officeComments}}</td>
                    </tr>
                  </table>

                  <table>
                    <tr>
                      <td style="font-weight: bold;">Comments: </td>
                      <td>{{demog.comments}}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>
    <span style="width: 100%;border-top: 1px solid grey"></span>

    <!-- Survey -->
    <div class="flex flex-col" *ngIf="reportMode == 'list'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Surveys</h5>
              <span style="width: 100%;border-top: 1px solid grey"></span>

              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="surveys.length > 0">
                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="surveyDate">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Survey Date</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyDate}}</td>
                    </ng-container>
                    <ng-container matColumnDef="surveyType">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Survey Type</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyType}}</td>
                    </ng-container>
                    <ng-container matColumnDef="surveyors">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Surveyors</th>
                      <td mat-cell *matCellDef="let item">{{item.surveyor1}} {{item.surveyor2}} {{item.surveyor3}}</td>
                    </ng-container>
                    <ng-container matColumnDef="conditionLevel">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Cond. Level</th>
                      <td mat-cell *matCellDef="let item">{{item.conditionLevel}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="followUpDue">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Follow Up Due</th>
                      <td mat-cell *matCellDef="let item">{{item.followUpDue}}</td>
                    </ng-container>
                    <ng-container matColumnDef="followUpDone">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Follow Up Done</th>
                      <td mat-cell *matCellDef="let item">{{item.followUpDone}}</td>
                    </ng-container>
                    <ng-container matColumnDef="onSiteFollowUp">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>On-Site Follow Up</th>
                      <td mat-cell *matCellDef="let item">{{item.onSiteFollowUp}}</td>
                    </ng-container>
                    <ng-container matColumnDef="deficiencies">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Deficiencies</th>
                      <td mat-cell *matCellDef="let item">{{item.deficienciesList.length}}</td>
                    </ng-container>
                    <ng-container matColumnDef="hoursOnSite">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Hours On Site</th>
                      <td mat-cell *matCellDef="let item">{{item.hoursOnSite}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>
    <span style="width: 100%;border-top: 1px solid grey"></span>

    <!-- Specialties -->
    <div class="flex flex-col" *ngIf="reportMode == 'list'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Specialties</h5>
              <span style="width: 100%;border-top: 1px solid grey"></span>

              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="surveys.length > 0">
                  <table mat-table [dataSource]="dataSource2" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="specialty">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Specialty</th>
                      <td mat-cell *matCellDef="let item">{{item.majorCat}}</td>
                    </ng-container>
                    <ng-container matColumnDef="tcd">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>TCD</th>
                      <td mat-cell *matCellDef="let item">{{item.t_CD}}</td>
                    </ng-container>
                    <ng-container matColumnDef="subSpecialty">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub-Specialty</th>
                      <td mat-cell *matCellDef="let item">{{item.code}}</td>
                    </ng-container>
                    <ng-container matColumnDef="pt">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>PT</th>
                      <td mat-cell *matCellDef="let item">{{item.pt}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="volume">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Volume</th>
                      <td mat-cell *matCellDef="let item">{{item.volume}}</td>
                    </ng-container>
                    <ng-container matColumnDef="opened">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Opened</th>
                      <td mat-cell *matCellDef="let item">{{item.dateOpened}}</td>
                    </ng-container>
                    <ng-container matColumnDef="closed">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Closed</th>
                      <td mat-cell *matCellDef="let item">{{item.dateClosed}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>
    <span style="width: 100%;border-top: 1px solid grey"></span>

    <!-- Proficiency Test Results -->
    <div class="flex flex-col" *ngIf="reportMode == 'list'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
            'bg-gray-700': sharedService.userTheme === 'dark',
            'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Proficiency Test Results</h5>
              <div style="overflow-x:auto">
                <div class="flex flex-row">
                  <table mat-table [dataSource]="dataSource3" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="specialty">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Specialty</th>
                      <td mat-cell *matCellDef="let item">{{item.specialty}}</td>
                    </ng-container>
                    <ng-container matColumnDef="subSpecialty">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub-Specialty</th>
                      <td mat-cell *matCellDef="let item">{{item.subSpecialty}}</td>
                    </ng-container>
                    <ng-container matColumnDef="testCode">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Test Code</th>
                      <td mat-cell *matCellDef="let item">{{item.testCode}}</td>
                    </ng-container>
                    <ng-container matColumnDef="analyte">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Analyte</th>
                      <td mat-cell *matCellDef="let item">{{item.analyte}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="testId">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Test ID</th>
                      <td mat-cell *matCellDef="let item">{{item.testId}}</td>
                    </ng-container>
                    <ng-container matColumnDef="yyyy1">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{dateNowYear - 1}}(1)</th>
                      <td mat-cell *matCellDef="let item">{{item.yrResult0_1 != null? item.yrResult0_1.ptPercent: ''}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="yyyy2">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{dateNowYear - 1}}(2)</th>
                      <td mat-cell *matCellDef="let item">{{item.yrResult0_2 != null? item.yrResult0_2.ptPercent: ''}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="yyyy3">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{dateNowYear - 1}}(3)</th>
                      <td mat-cell *matCellDef="let item">{{item.yrResult0_3 != null? item.yrResult0_3.ptPercent: ''}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="yyyy4">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{dateNowYear}}(1)</th>
                      <td mat-cell *matCellDef="let item">{{item.yrResult1_1 != null? item.yrResult1_1.ptPercent: ''}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="yyyy5">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{dateNowYear}}(2)</th>
                      <td mat-cell *matCellDef="let item">{{item.yrResult1_2 != null? item.yrResult1_2.ptPercent: ''}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="yyyy6">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{dateNowYear}}(3)</th>
                      <td mat-cell *matCellDef="let item">{{item.yrResult1_3 != null? item.yrResult1_3.ptPercent: ''}}
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns3;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>
    <span style="width: 100%;border-top: 1px solid grey"></span>
  </kendo-pdf-export>

</div>